import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
// eslint-disable-next-line @juvare/custom-rules/no-restricted-backend-feature-imports
import { defaultSystemRoles } from '@juvare/contact-management/backend/features/permissions'; // TODO: Change to shared folder after PFCM-1393
import { Typography } from '@mui/material';
import React from 'react';
import { AccountBadgeActionsCell } from '../components/AccountBadgeTable/AccountBadgeActionsCell';
import { AccountBadgeDistributionCell } from '../components/AccountBadgeTable/AccountBadgeDistributionCell';
import { BadgeNameCell } from '../components/AccountBadgeTable/AccountBadgeNameCell';
import { BadgeStatusCell } from '../components/AccountBadgeTable/AccountBadgeStatusCell';
import { AccountBadgeContext } from '../contexts/AccountBadgeContext';
export function useAccountBadgeListColumns({ fetchAccountBadgeList, }) {
    const { t } = useBadgingTranslation();
    const { extendAccountBadgeTableColumns } = React.useContext(AccountBadgeContext);
    const defaultColumns = [
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.badgeName'),
            sortKey: 'fullName',
            cellFunction: (row) => (React.createElement(BadgeNameCell, { id: row.id, fullName: row.columns.accountDisplayName, description: React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, defaultSystemRoles[row.columns.accountSystemRole].label) })),
        },
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.status'),
            sortKey: 'status',
            cellFunction: (row) => (React.createElement(BadgeStatusCell, { status: row.columns.status, statusLastUpdatedAt: row.columns.statusLastUpdatedAt, statusReasonTitle: row.columns.statusReasonTitle, expiresAt: row.columns.expiresAt })),
        },
        {
            headerLabel: t('badges.badgeDetails.accountBadgeTable.headerLabels.distribution'),
            sortKey: 'distributionStatus',
            cellFunction: (row) => React.createElement(AccountBadgeDistributionCell, { accountBadge: row, fetchAccountBadgeList: fetchAccountBadgeList }),
        },
        {
            cellFunction: (row) => {
                return React.createElement(AccountBadgeActionsCell, { accountBadge: row, fetchAccountBadgeList: fetchAccountBadgeList });
            },
        },
    ];
    return extendAccountBadgeTableColumns ? extendAccountBadgeTableColumns(defaultColumns) : defaultColumns;
}
